exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"DataManagementView.scss","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/Modals/Settings/SettingsViews/DataManagementView/DataManagementView.scss
// module id = 2102
// module chunks = 0